/**
 * @project 中国人群健康大数据平台
 * 
 * @author  Guojun Wang
 * @date    2022-11-21 14:00:00
 **/ 

import React from 'react';

import { BannerItemsConfig } from './data.source';

class Banner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      default: true,
    };
  };

  componentDidMount() {
    const item = document.getElementsByClassName('banner-icon');

    for (let i = 0; i < 6; i++) {
      item[i].onmouseover = () => {
        this.setState({
          default: false
        })
      }

      item[i].onmouseout = () => {
        this.setState({
          default: true
        })
      }
    }
  };

  render() {
    const { ...currentProps } = this.props;
    const { dataSource } = currentProps;
    delete currentProps.dataSource;
    delete currentProps.isMobile;

    return (
      <div {...currentProps} {...dataSource.wrapper}>
        <div className='home-banner-wrapper'>
          <div className='home-banner-wrapper-module'>
            {/* 科研软件 */}
            <div className="home-module-software">
              <img src="/assets/images/home-software-bg.png" alt="科研软件"/>
              <div className="home-module-software-link">
                {
                  BannerItemsConfig.map((item, i) => {
                    return (
                      <a
                        key={i}
                        target={`${item.name === 'DENTIST' ? '_blank' : '_self'}`} 
                        href={item.href} 
                        rel="noopener noreferrer" 
                        className={`banner-icon banner-icon-${item.name} ${this.state.default ? `banner-icon-default-${item.name}` : ''}`}
                      >
                        <div className="banner-icon-pos">
                          <div className="banner-icon-fullname">{item.fullName}</div>
                        </div>
                      </a>
                    )
                  })
                }
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">RESEARCH SOFTWARE</div>
                {/* <a href="/software-gcta">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a> */}
              </div>
            </div>

            {/* WBBC数据库 */}
            <div className="home-module-wbbc">
              <img src="/assets/images/home-g2g.png" alt="WBBC数据库"/>
              <div className="wbbc-content">
                <div className="wbbc-content-title" style={{marginBottom:20}}>SMR Portal</div>
                {/* <div className="wbbc-content-subTitle">Genetic Associations to Mechanisms and Medicine Analysis</div> */}
                <div className="wbbc-content-detail">SMR Portal is designed to facilitate the integrative analysis of GWAS and xQTL summary statistics using the SMR & HEIDI methods, aiming to identify genes associated with complex traits, including diseases, and to enhance the accessibility of the identified gene-trait associations for the research community.</div>
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">SMR PORTAL</div>
                <a href="https://yanglab.westlake.edu.cn/smr-portal/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a>
              </div>
            </div>

            {/* BrainMeta数据集 */}
            {/* <div className="home-module-brainMeta">
              <img src="/assets/images/home-meta.png" alt="BrainMeta数据集"/>
              <div className="module-database">
                <div className="module-database-left">
                  <div className="module-database-title">BrainMeta data portal</div>
                  <a href="/meta">
                  <img className='module-database-left-img' src="/assets/images/brain-meta.png" alt="BrainMeta data portal" />
                  </a>
                </div>
                <div className="module-database-right">
                  <div className="module-database-title">fastGWA data portal</div>
                  <a href="/data">
                  <img className='module-database-right-img' src="/assets/images/fast-gwa.png" alt="fastGWA data portal" />
                  </a>
                </div>
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">DATA PORTAL</div>
                <a href="/meta">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a>
              </div>
            </div> */}

{/* BrainMeta数据集 */}
<div className="home-module-brainMeta">
              <img src="/assets/images/home-meta.png" alt="BrainMeta数据集"/>
              <div className="module-database">
                <div className="module-database-left">
                  <div className="module-database-title">BrainMeta data portal</div>
                  <a href="/meta">
                  <img className='module-database-left-img' src="/assets/images/GWAS_img1.png" alt="BrainMeta data portal" />
                  </a>
                </div>
               
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">DATA PORTAL</div>
                <a href="/meta">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a>
              </div>
            </div>
{/* fastGWA数据集 */}
<div className="home-module-fastGWA">
              <img src="/assets/images/home-wbbc-bg.png" alt="fastGWA数据集"/>
              <div className="module-database">
                
                <div className="module-database-right">
                  <div className="module-database-title">fastGWA data portal</div>
                  <a href="/data">
                  <img className='module-database-right-img' src="/assets/images/fast-gwa.png" alt="fastGWA data portal" />
                  </a>
                </div>
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">DATA PORTAL</div>
                <a href="/meta">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a>
              </div>
            </div>
            {/* fastGWA数据集 */}
            {/* <div className="home-module-fastGWA">
              <img src="/assets/images/home-wbbc-bg.png" alt="fastGWA数据集"/>
              <div className="wbbc-content">
                <div style={{display:'flex',flexDirection:'row'}}>
              <img src="/assets/images/WBBC_logo.png" alt="查看详情" className='wbbc-logo'/>
              <div style={{display:'flex',flexDirection:'column'}}>
                <div className="wbbc-content-title">WBBC</div>
                <div className="wbbc-content-subTitle">Westlake BioBank for Chinese</div>
                </div>
                </div>
                <div className="wbbc-content-detail">The Westlake BioBank for Chinese (WBBC) project is a population-based prospective study with its major purpose to better understand the effect of genetic and environmental factors on growth and development from young to old. The WBBC is designed to recruit at least 100,000 Chinese samples across the country.</div>
              </div>
              <div className="software-bottom">
                <div className="software-bottom-label">DATABASE</div>
                <a href="https://wbbc.westlake.edu.cn/index.html" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/detail-icon.png" alt="查看详情" />
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
export default Banner;
